import PageHeader from 'src/components/organisms/PageHeader';
import Footer from 'src/components/molecules/footer/Footer';
import ContentCardsContainer, { CardType, ContentCard } from 'src/components/organisms/ContentCard';
import { CustomDataGrid } from 'src/components/organisms/CustomDataGrid';
import { generateTablePageButtons } from 'src/utils/generateTablePageButtons';
import { usePurchasingShippingTermsTable } from 'src/hooks/table/configs/usePurchasingShippingTermsTable';

export  const PurchasingShippingTerms = () => {
    const [columns, tableSettings] = usePurchasingShippingTermsTable();
    return (
        <>
            <PageHeader  {...{
                title: "Purchasing Shipping Terms",
                subTitle: "Manage terms for shipping from suppliers", 
                components: [
                    ...generateTablePageButtons(tableSettings),
                ]
            }} />
         <ContentCardsContainer >
                <ContentCard {...{ cardTypes: [CardType.noHeader], contentPadding: 0 }}>
                    <CustomDataGrid columns={columns} tableSettings={tableSettings} /> 
                </ContentCard>
            </ContentCardsContainer>


            <Footer />
        </>
    );
}
export default  PurchasingShippingTerms;

